import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ProjectsIcon from '@mui/icons-material/AccountTree';
import RBACIcon from '@mui/icons-material/AdminPanelSettings';
import ApartmentIcon from '@mui/icons-material/Apartment';
import ArticleIcon from '@mui/icons-material/Article';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import ClientsIcon from '@mui/icons-material/ContactPhone';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DataSaverIcon from '@mui/icons-material/DataSaverOnOutlined';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import DynamicFormIcon from '@mui/icons-material/DynamicForm';
import GroupIcon from '@mui/icons-material/Group';
import HandshakeIcon from '@mui/icons-material/Handshake';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import ListAltIcon from '@mui/icons-material/ListAlt';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ProfileIcon from '@mui/icons-material/Person';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import PhoneIcon from '@mui/icons-material/Phone';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import RuleIcon from '@mui/icons-material/Rule';
import SendIcon from '@mui/icons-material/Send';
import StorageIcon from '@mui/icons-material/Storage';
import TuneIcon from '@mui/icons-material/Tune';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';

import { SIDEBAR_VIEW_NAVIGATION_STATE } from 'analytics/constants';
import { getRoutePermissions, LEGACY_CLIENTS_VIEW_ACCESS_STATE } from 'routes/routePermissions';

import { NavItem } from './Sidebar.types';

export const PRINCIPAL_BASE_ITEMS: NavItem[] = [
  {
    text: 'Funnel',
    path: '/funnel',
    searchParams: { view: null },
    desktopOnly: true,
    Icon: ViewKanbanIcon,
    permissions: getRoutePermissions('/funnel'),
    state: SIDEBAR_VIEW_NAVIGATION_STATE,
  },
  {
    text: 'Chat',
    path: '/funnel',
    searchParams: { view: 'chat' },
    Icon: ChatBubbleOutlineIcon,
    permissions: getRoutePermissions('/funnel'),
    state: SIDEBAR_VIEW_NAVIGATION_STATE,
  },
  {
    text: 'Tabla',
    path: '/funnel',
    searchParams: { view: 'table' },
    desktopOnly: true,
    Icon: ListAltIcon,
    permissions: getRoutePermissions('/funnel'),
    state: SIDEBAR_VIEW_NAVIGATION_STATE,
  },
  {
    text: 'Leads',
    path: '/leads',
    Icon: PersonSearchIcon,
    permissions: getRoutePermissions('/leads'),
    badge: 'nuevo',
  },
  { text: 'Soporte', path: '/', Icon: DashboardIcon },
  { text: 'Feedback', path: '/feedback', Icon: RecordVoiceOverIcon },
  { text: 'Proyecto', path: '/project', Icon: ProjectsIcon },
  {
    text: 'Análisis (βeta)',
    path: '/analysis',
    Icon: AutoGraphIcon,
    badge: 'Beta',
    permissions: getRoutePermissions('/analysis'),
  },
  { text: 'Preguntas', path: '/questions', Icon: QuestionMarkIcon },
  { text: 'Alertas', path: '/alerts', Icon: NotificationsIcon },
  { text: 'Templates', path: '/templates', Icon: DocumentScannerIcon, permissions: getRoutePermissions('/templates') },
  {
    text: 'Partner Center',
    path: '/partner-center',
    Icon: HandshakeIcon,
    permissions: getRoutePermissions('/partner-center'),
  },
  {
    text: 'Brokerage',
    path: '/brokerage',
    Icon: AccountBalanceIcon,
    permissions: getRoutePermissions('/brokerage'),
  },
  {
    text: 'Llamadas',
    path: '/calls',
    Icon: PhoneIcon,
    permissions: getRoutePermissions('/calls'),
  },
  {
    text: 'Mensajería',
    path: '/template-sender',
    Icon: SendIcon,
    permissions: getRoutePermissions('/template-sender'),
  },
];

export const REPORTE_ITEM: NavItem = {
  text: 'Reporte',
  path: '/looker',
  Icon: DataSaverIcon,
  permissions: getRoutePermissions('/looker'),
};

/** Shown to admins, and to other users only with the `academy` flag on (see useNavigationGroups). */
export const ACADEMY_ITEM: NavItem = { text: 'Academy', action: 'moodle-sso', Icon: MenuBookIcon };

export const CUENTA_ITEMS: NavItem[] = [{ text: 'Mi perfil', path: '/profile', Icon: ProfileIcon }];

export const ADMIN_ITEMS: NavItem[] = [
  { text: 'Propiedades', path: '/properties', Icon: ApartmentIcon },
  {
    text: 'Clientes',
    path: '/clients',
    Icon: ClientsIcon,
    permissions: getRoutePermissions('/clients'),
    state: LEGACY_CLIENTS_VIEW_ACCESS_STATE,
  },
  {
    text: 'DB reader',
    path: '/db-reader',
    Icon: StorageIcon,
    permissions: getRoutePermissions('/db-reader'),
  },
  {
    text: 'Análisis Hipotecario',
    path: '/mortgage-analysis',
    Icon: AccountBalanceIcon,
    permissions: getRoutePermissions('/mortgage-analysis'),
  },
  { text: 'Información', path: '/information', Icon: TuneIcon },
  { text: 'Automatizaciones', path: '/rule-configs', Icon: RuleIcon },
  { text: 'Mapeo de orígenes', path: '/source-mapping', Icon: RuleIcon },
  { text: 'Usuarios', path: '/users', Icon: GroupIcon },
  { text: 'RBAC', path: '/rbac', Icon: RBACIcon, permissions: getRoutePermissions('/rbac') },
  { text: 'Secciones Globales', path: '/global-prompt-sections', Icon: ArticleIcon },
  { text: 'Cargar Propiedades', path: '/upsert-properties', Icon: HomeWorkIcon },
  { text: 'Business Rules', path: '/business-rules', Icon: RuleIcon },
  { text: 'Reglas de Asignación', path: '/assignment-rules', Icon: RuleIcon },
  {
    text: 'WhatsApp Flows',
    path: '/whatsapp-flows',
    Icon: DynamicFormIcon,
    permissions: getRoutePermissions('/whatsapp-flows'),
  },
];
